<template lang="pug">
    div
        b-btn.m-3(v-b-modal="'search_college' + multi_field_num" size="sm")
            | Search for a College
        q_text(
        question="Name"
        slug="q_college_name"
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="Country"
        slug="q_college_country"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="City"
        slug="q_college_city"
        :multi_field_num="multi_field_num"
        )
        q_dynamic_ddl(
        question="State"
        slug="q_college_state"
        :multi_field_num="multi_field_num"
        )
        q_dynamic_ddl(
        question="Province"
        slug="q_college_province"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="CEEB Code"
        slug="q_college_ceeb"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Credits Attempted"
        slug="q_college_credits_attempted"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Attended Full or Part Time"
        slug="q_college_full_part_time"
        :multi_field_num="multi_field_num"
        )
        q_date(
        question="Attended Start"
        slug="q_college_attended_start"
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
        q_date(
        question="Attended End"
        slug="q_college_attended_end"
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
        q_date(
        question="Graduation Date"
        slug="q_college_grad_date"
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
        div
            CollegeSearch(v-bind:multi_field_num="multi_field_num")

</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_text from "../../baseQuestion/text";
import q_dynamic_ddl from "../../baseQuestion/dynamicDDL";
import q_searchable_ddl from "../../baseQuestion/searchableDDL";
import q_static_ddl from "../../baseQuestion/staticDDL";
import q_date from "../../baseQuestion/date";
import CollegeSearch from "../../collegeSearch";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_text,
		q_dynamic_ddl,
		q_searchable_ddl,
		q_static_ddl,
		CollegeSearch,
		q_date
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		}
	}
};
</script>
